import axios from "@modules/axios";

document.addEventListener(
  `DOMContentLoaded`,
  () => {
    const changeOption = (selector, label) => {
      const field = document.querySelector(selector);
      if (field) {
        const option = field.querySelector("option:first-child");
        if (option) {
          option.innerHTML = label;
          option.disabled = true;
        }
      }
    };

    // Change birthday labels and disable placeholder option.
    changeOption('#buddypress select[name$="day"]', "Dag");
    changeOption('#buddypress select[name$="month"]', "Maand");
    changeOption('#buddypress select[name$="year"]', "Jaar");

    // Handle newsletter unsubscription.
    const form = document.querySelector("#unsubscribe-form");
    form?.addEventListener("submit", async function (event) {
      event.preventDefault();
      form.querySelector("#form-error")?.remove();

      let formData = new FormData();
      formData.append("action", "unsubscribe_newsletter");
      formData.append("security", frameworkGlobal.nonce);
      formData.append(
        "email",
        document.querySelector('#unsubscribe-form [name="email"]')?.value ?? ""
      );

      const loadingIndicator = form.querySelector("iconify-icon");
      loadingIndicator.style.display = "inline-flex";
      const response = await axios.post(frameworkGlobal.ajaxurl, formData);
      if (response.data?.success === true) {
        document.querySelector("#unsubscribe-content").style.display = "none";
        document.querySelector("#unsubscribe-success").style.display = "block";
        form.reset();
      } else {
        form.insertAdjacentHTML(
          "afterbegin",
          `<div id="form-error" class="alert callout text-left"><p>${response.data?.error}</p></div>`
        );
      }
      loadingIndicator.style.display = "none";
    });
  },
  { passive: true }
);
